import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { useSiteMedia } from "@/lib/siteImages";
import Reveal from "@/components/Reveal";

export default function Lookbook() {
  const { t } = useLanguage();
  const media = useSiteMedia();
  const frames = [
    { img: media("lab"), cap: t.look.c1, span: "lg:col-span-7", ratio: "aspect-[16/10]" },
    { img: media("nature"), cap: t.look.c2, span: "lg:col-span-5", ratio: "aspect-[4/5]" },
    { img: media("dynamic"), cap: t.look.c3, span: "lg:col-span-5", ratio: "aspect-[4/5]" },
    { img: media("woman"), cap: t.look.c4, span: "lg:col-span-7", ratio: "aspect-[16/10]" },
    { img: media("clean"), cap: t.look.c5, span: "lg:col-span-7", ratio: "aspect-[16/10]" },
    { img: media("soft"), cap: t.look.c6, span: "lg:col-span-5", ratio: "aspect-[4/5]" },
  ];

  return (
    <div data-testid="lookbook-page" className="bg-white">
      <section className="relative overflow-hidden border-b border-navy/10 bg-surface pb-16 pt-28">
        <span aria-hidden className="text-ghost pointer-events-none absolute -bottom-8 end-0 select-none font-display text-[15vw] italic leading-none">
          Lookbook
        </span>
        <div className="relative mx-auto max-w-7xl px-6">
          <Reveal><p className="label-luxe text-gold-dark">{t.look.kicker}</p></Reveal>
          <Reveal delay={1}>
            <h1 className="mt-5 font-display text-5xl font-light tracking-tight text-navy sm:text-6xl">{t.look.title}</h1>
          </Reveal>
          <Reveal delay={2}>
            <p className="mt-5 max-w-lg text-sm font-light text-navy/50">{t.look.sub}</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-24">
        <div className="grid gap-6 lg:grid-cols-12">
          {frames.map((f, i) => (
            <Reveal key={i} delay={i % 2} className={f.span}>
              <figure data-testid={`lookbook-frame-${i}`} className="group relative overflow-hidden border border-navy/10">
                <div className={`img-zoom-frame ${f.ratio}`}>
                  <img src={f.img} alt={f.cap} className="h-full w-full object-cover" loading="lazy" />
                </div>
                <span aria-hidden className="card-index pointer-events-none absolute end-5 top-4 text-6xl">
                  0{i + 1}
                </span>
                <figcaption className="absolute inset-x-0 bottom-0 bg-navy/85 px-6 py-4 backdrop-blur-sm">
                  <p className="font-display text-lg font-light italic text-white">{f.cap}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="relative overflow-hidden bg-navy py-24 text-center text-white noise-bg">
        <div className="spotlight absolute inset-0" />
        <div className="relative mx-auto max-w-2xl px-6">
          <Reveal>
            <p className="font-display text-3xl font-light italic sm:text-4xl">{t.manifesto.title}</p>
          </Reveal>
          <Reveal delay={1} className="mt-10">
            <Link to="/shop" data-testid="lookbook-cta" className="btn-gold-luxe">
              {t.actions.shopNow}
              <ArrowRight size={14} className="rtl:rotate-180" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
